import { redirect } from '@tanstack/react-router';

export const STRIPE_RETURN_PATH = '/payment/confirmation' as const;

export interface StripeReturnSearch {
  redirectStatus?: string;
}

export interface PaymentSearch {
  paymentFailed?: boolean;
}

export function validateStripeReturnSearch(search: Record<string, unknown>): StripeReturnSearch {
  return {
    redirectStatus: typeof search.redirect_status === 'string' ? search.redirect_status : undefined,
  };
}

export function validatePaymentSearch(search: Record<string, unknown>): PaymentSearch {
  return { paymentFailed: search.paymentFailed === true ? true : undefined };
}

export function handleStripeReturn({ redirectStatus }: StripeReturnSearch): void {
  if (redirectStatus === 'failed') {
    throw redirect({ to: '/payment', search: { paymentFailed: true } });
  }
}
